import { ICustomerAddress } from '@/common/interfaces/customers.interface';
import { IAddress } from '@/common/interfaces/shared.interface';
import { IUpdateAddress } from '@/common/interfaces/my-profile.interface';

export default class AddressHelper {
  public static isValidSpainPostCode(zipCode: string): boolean {
    return zipCode.substr(0, 2) !== `38` && zipCode.substr(0, 2) !== `35` && zipCode.length === 5;
  }

  public static isValidCanaryIslandPostCode(zipCode: string): boolean {
    return (zipCode.substr(0, 2) === `38` || zipCode.substr(0, 2) === `35`) && zipCode.length === 5;
  }

  public static transformAddressToCustomerAddress(address: IAddress): ICustomerAddress {
    return {
      country: ``,
      postalCode: ``,
      useTaxNumber: false,
      ...address,
    };
  }

  public static transformAddressToDisplayString(address: IAddress, withoutRecipient = false): string {
    const recipient = withoutRecipient ? `` : `${address.recipient}, `;
    const street = address.streetNumber ? `${address.street} ${address.streetNumber}, ` : `${address.street}, `;
    const extra = address.extra ? `${address.extra}, ` : ``;
    const city = `${address.zipCode} ${address.city}, `;
    const country = `${address.state ? `${address.state}, ` : ``}${address.country}`;

    return `${recipient}${street}${extra}${city}${country}`;
  }

  public static transformAddressToUpdateAddress(address: IAddress): IUpdateAddress {
    return {
      additionalText: address.extra,
      city: address.city,
      countryISO: address.countryISO,
      customerNumber: address.customerNumber,
      deliveryDefault: address.deliveryDefault,
      id: address.id,
      recipient: address.recipient,
      stateId: address.stateId ? +address.stateId : undefined,
      street: address.street,
      streetNumber: address.streetNumber,
      zipCode: address.zipCode,
    };
  }
}
